import React, { useState, useEffect } from 'react';

import {
  faCommentDots,
  faExternalLinkAlt,
  faTimesCircle,
  faChartBar,
  faListOl,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  PopoverHeader,
  UncontrolledTooltip,
} from 'reactstrap';

import { questionTypes } from './constants';

import style from './AdminRankResponses.style';
import AdminRankResponse from './AdminRankResponse/AdminRankResponse';

import './AdminRankResponses.style.css';
import { clone } from '../../../../../../Services/schedule';
import { checkLoginForError, formatBearerToken } from '../../../../../../Common.functions';
import { useAuth0 } from '../../../../../../auth0/reactAuth0Spa';
import { fetchDataAgnostic } from '../../../../../../Services/dataApi';
import { popoverModifiers } from 'enums';
const AdminRankResponses = ({
  isGettingResponses,
  selectedUser,
  responses,
  getCandidateResponses,
  dContext,
  mode,
  canGoPreviousCandidate,
  canGoNextCandidate,
  onPreviousCandidate,
  onNextCandidate,
}) => {
  const [filterBy, setFilterBy] = useState({ QuestionText: 'No Data' }); // if not 'comments', assume by pk_EvaluationQuestion
  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const [showExpandedView, setShowExpandedView] = useState(false);
  const [displayMode, setDisplayMode] = useState('individual');

  const [questions, setQuestions] = useState([]);
  const [defaultScale, setDefaultScale] = useState(null);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (responses && responses.length > 0) {
      if (filterBy && filterBy.QuestionText !== 'No Data') {
        const filterExists = questions.find((r) => {
          return r.pk_EvaluationQuestion == filterBy.pk_EvaluationQuestion;
        });
        if (filterExists) {
          setFilterBy(filterExists);
        } else {
          setFilterBy(responses[0]);
        }
      } else {
        setFilterBy(responses[0]);
      }
    }
  }, [responses]);

  useEffect(() => {
    getQuestions();
  }, [mode]);

  useEffect(() => {}, []);

  useEffect(() => {
    getQuestions();
  }, [dContext]);

  const getQuestions = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/questions',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((result) => {
            if (result.data && result.data.EvalQuestions) {
              const newQuestionList = [];
              result.data.EvalQuestions.forEach((group) => {
                if (group.questions) {
                  // evaluation: 1,
                  // prescreen: 2,
                  group.questions.forEach((q) => {
                    if ((mode == 1 && q.EnableEvaluationForm) || (mode == 2 && q.EnablePrescreenForm)) {
                      newQuestionList.push(q);
                    }
                  });
                }
              });
              newQuestionList.sort((a, b) => {
                return a.EvaluationQuestionSortOrder - b.EvaluationQuestionSortOrder;
              });
              setQuestions(newQuestionList);
              if (newQuestionList.length > 0) {
                setFilterBy(newQuestionList[0]);
              }
            } else {
              // setQuestions([newQuestions]);
            }

            // Store the DefaultScale for questions without CustomScale
            if (result.data && result.data.DefaultScale) {
              setDefaultScale(result.data.DefaultScale);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getMaxAnswerValue = (answers = [], questionScale = null) => {
    if (questionScale && Array.isArray(questionScale) && questionScale.length > 0) {
      const sorted = [...questionScale].sort((a, b) => {
        const aValue = a.DisplayValue != null ? a.DisplayValue : a.NumericValue;
        const bValue = b.DisplayValue != null ? b.DisplayValue : b.NumericValue;
        return bValue - aValue;
      });
      const top = sorted[0];
      return top.DisplayValue != null ? top.DisplayValue : top.NumericValue;
    }

    if (answers.length > 0) {
      const maxFromAnswers = Math.max(...answers.map((a) => a.MaxAnswerValue || a.AnswerNumber || 0));
      if (maxFromAnswers > 0) {
        return maxFromAnswers;
      }
    }

    return 5;
  };

  const getDistributionColor = (fillRatio) => {
    if (fillRatio == null || fillRatio <= 0) {
      return 'transparent';
    }
    if (fillRatio >= 1) {
      return '#a8d623';
    }
    const ratio = Math.max(0, Math.min(fillRatio, 1));
    const hue = Math.round(ratio * 120); // 0=red, 120=green
    return `hsl(${hue}, 90%, 54%)`;
  };

  const renderDistributionQuestion = ({ question, answers = [], questionScale = null, index = 0 }) => {
    const maxAnswerValue = getMaxAnswerValue(answers, questionScale);
    const totalInterviewers = answers.length;
    const questionType = question.QuestionTypeNumber1OrText2 || question.questionType;

    if (questionType == 2) {
      return (
        <div style={style.distributionQuestionCard} key={`distribution_q_${question.pk_EvaluationQuestion || index}`}>
          <div style={style.distributionQuestionHeader}>
            <div>
              {`#${index + 1}. `}
              {question.QuestionText || ''}
            </div>
          </div>
          <div style={style.distributionEmptyState}>Distribution view is available for scored questions only.</div>
        </div>
      );
    }

    const distributionMap = {};
    for (let i = 1; i <= maxAnswerValue; i++) {
      distributionMap[i] = 0;
    }
    answers.forEach((answer) => {
      const responseNumber = answer.AnswerNumber || 0;
      if (distributionMap[responseNumber] != null) {
        distributionMap[responseNumber] += 1;
      }
    });

    const values = [];
    for (let value = maxAnswerValue; value >= 1; value--) {
      values.push(value);
    }

    return (
      <div style={style.distributionQuestionCard} key={`distribution_q_${question.pk_EvaluationQuestion || index}`}>
        <div style={style.distributionQuestionHeader}>
          <div>
            {`#${index + 1}. `}
            {question.QuestionText || ''}
          </div>
          <div>{`Total Interviewers: ${totalInterviewers}`}</div>
        </div>
        <div style={style.distributionRows}>
          {values.map((responseValue) => {
            const count = distributionMap[responseValue] || 0;
            const fillRatio = count > 0 && totalInterviewers > 0 ? count / totalInterviewers : 0;
            const widthPercent = fillRatio * 100;
            const fillColor = getDistributionColor(fillRatio);

            return (
              <div style={style.distributionRow} key={`response_${question.pk_EvaluationQuestion}_${responseValue}`}>
                <div style={style.distributionLabel}>{`Response: ${responseValue}`}</div>
                <div style={style.distributionTrack}>
                  {count > 0 ? (
                    <div
                      style={{
                        ...style.distributionFill,
                        width: `${widthPercent}%`,
                        backgroundColor: fillColor,
                      }}
                    >
                      {`${count}/${totalInterviewers}`}
                    </div>
                  ) : (
                    <div style={style.distributionZeroLabel}>{`${count}/${totalInterviewers}`}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderFilterPopover = () => {
    return (
      <Popover
        flip={false} // popperClassName="responsesFilterPopover"
        placementPrefix="responsesFilterPopover bs-popover"
        modifiers={popoverModifiers}
        placement="bottom"
        isOpen={showFilterPopover}
        trigger="legacy"
        target="filter_button"
        toggle={() => {
          setShowFilterPopover(!showFilterPopover);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div>Filter</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowFilterPopover(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <div style={{ overflowY: 'scroll', height: 150 }}>
            {questions.map((question, i) => {
              const backgroundColor =
                question.pk_EvaluationQuestion === filterBy.pk_EvaluationQuestion
                  ? 'var(--rr-primary-soft)'
                  : i % 2 == 0
                  ? 'var(--rr-surface-stripe)'
                  : 'white';

              return (
                <div
                  style={{ ...style.filterItem, backgroundColor }}
                  value={question.pk_EvaluationQuestion}
                  onClick={() => {
                    setFilterBy(question);
                    setShowFilterPopover(false);
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={question.QuestionTypeNumber1OrText2 == 2 ? faCommentDots : faListOl} />
                  </div>
                  <div style={style.centeredText}>
                    {i + 1}. {question.QuestionText}
                  </div>
                </div>
              );
            })}
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  const renderExpandedView = () => {
    return (
      <Modal
        isOpen={showExpandedView}
        style={{ maxWidth: '90vw', width: '90vw' }}
        onClosed={() => {
          setShowExpandedView(false);
        }}
      >
        <ModalHeader
          closeButton
          style={{ position: 'relative', paddingRight: 220 }}
          toggle={() => {
            setShowExpandedView(false);
          }}
        >
          <div style={{ ...style.spacedBetweenRow, width: 'calc(90vw - 60px)' }}>
            <div>
              {selectedUser
                ? `${selectedUser.LastName ? `${selectedUser.LastName}, ` : ''} ${selectedUser.FirstName || ''}`
                : ''}
            </div>

            <div>
              <Button
                style={{ marginRight: 5 }}
                size="sm"
                className="p-0 px-2"
                onClick={onPreviousCandidate}
                disabled={!canGoPreviousCandidate}
              >
                <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: 4 }} />
                Previous
              </Button>
              <Button
                style={{ marginRight: 5 }}
                size="sm"
                className="p-0 px-2"
                onClick={onNextCandidate}
                disabled={!canGoNextCandidate}
              >
                Next
                <FontAwesomeIcon icon={faChevronRight} style={{ marginLeft: 4 }} />
              </Button>
              <Button
                size="sm"
                style={{ ...style.viewToggleButton, marginRight: 15 }}
                className="p-0"
                onClick={() => {
                  setDisplayMode(displayMode === 'individual' ? 'distribution' : 'individual');
                }}
                title={
                  displayMode === 'individual' ? 'Switch to Answer Distribution' : 'Switch to Individual Responses'
                }
              >
                <FontAwesomeIcon icon={displayMode === 'individual' ? faChartBar : faListOl} />
              </Button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ height: '80vh' }}>
          <div style={{ ...style.responsesContainer, height: '73vh' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              {displayMode === 'distribution'
                ? questions.map((question, i) => {
                    const { pk_EvaluationQuestion, CustomScale } = question;
                    const responsesToQuestion = responses.find((r) => {
                      return r.pk_EvaluationQuestion == pk_EvaluationQuestion;
                    });
                    const Answers = responsesToQuestion ? responsesToQuestion.Answers : [];
                    const questionScale = CustomScale || defaultScale;

                    return renderDistributionQuestion({ question, answers: Answers, questionScale, index: i });
                  })
                : questions.map((question, i) => {
                    const { pk_EvaluationQuestion, CustomScale } = question;
                    const filterType = filterBy.questionType || questionTypes.Rating;

                    const responsesToQuestion = responses.find((r) => {
                      return r.pk_EvaluationQuestion == pk_EvaluationQuestion;
                    });
                    const Answers = responsesToQuestion ? responsesToQuestion.Answers : [];
                    // Use CustomScale if available, otherwise use DefaultScale
                    const questionScale = CustomScale || defaultScale;

                    return (
                      <AdminRankResponse
                        item={{ ...question, Answers, index: i }}
                        filterType={filterType}
                        displayType="expanded"
                        questionScale={questionScale}
                      />
                    );
                  })}
            </div>

            {/* {responses.map((question, i) => {
              const filterType = filterBy.questionType;
              const evaluatorRatings = [];
              const item = {
                ...question,
                index: i + 1,
              };

              // Get Ratings for each evaluator
              // dummyEvaluators.forEach((evaluator) => {
              //   evaluatorRatings.push({
              //     ...evaluator,
              //     comment: question.questionType === questionTypes.Text ? getRandomComment() : null,
              //     rating: question.questionType === questionTypes.Rating ? Math.floor(Math.random() * 6) : null,
              //     maxRating: 5,
              //   });
              // });

              // item.evaluatorRatings = evaluatorRatings;
              return <AdminRankResponse item={{ ...item, index: i }} filterType={filterType} displayType="expanded" />;
            })} */}
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const responsesToRender = [];

  responses.forEach((response) => {
    const filterType = filterBy.QuestionTypeNumber1OrText2 || 1;
    if (response.pk_EvaluationQuestion == filterBy.pk_EvaluationQuestion) {
      // Find the matching question to get CustomScale
      const matchingQuestion = questions.find((q) => q.pk_EvaluationQuestion == response.pk_EvaluationQuestion);
      // Use CustomScale if available, otherwise use DefaultScale
      const questionScale = matchingQuestion?.CustomScale || defaultScale;

      response.Answers.forEach((answer, i) => {
        responsesToRender.push(
          <AdminRankResponse item={{ ...answer, index: i }} filterType={filterType} questionScale={questionScale} />,
        );
      });
    }
  });

  if (responsesToRender.length <= 0) {
    if (isGettingResponses) {
      responsesToRender.push(
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          Loading Responses. . .
        </div>,
      );
    } else {
      responsesToRender.push(
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          No responses recorded for this candidate.
        </div>,
      );
    }
  }

  let distributionContent = null;
  if (displayMode === 'distribution') {
    const responseForFilteredQuestion = responses.find((response) => {
      return response.pk_EvaluationQuestion == filterBy.pk_EvaluationQuestion;
    });
    const Answers = responseForFilteredQuestion ? responseForFilteredQuestion.Answers : [];
    const matchingQuestion = questions.find((q) => q.pk_EvaluationQuestion == filterBy.pk_EvaluationQuestion);
    const questionScale = matchingQuestion?.CustomScale || defaultScale;
    const selectedQuestion = matchingQuestion || filterBy || {};

    distributionContent = renderDistributionQuestion({
      question: selectedQuestion,
      answers: Answers,
      questionScale,
      index:
        selectedQuestion.EvaluationQuestionSortOrder != null ? selectedQuestion.EvaluationQuestionSortOrder - 1 : 0,
    });
  }

  return (
    <div style={{ ...style.simpleColumn, width: '100%', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
        <div style={{ ...style.simpleColumn, width: '100%' }}>
          <div style={{ ...style.simpleRow, marginTop: 10, alignItems: 'center', gap: 5, width: '100%' }}>
            <div style={{ ...style.simpleColumn, flex: '1 1 auto', minWidth: 0 }}>
              <Button id="filter_button" size="sm" style={{ width: '100%', minWidth: 0 }}>
                <div style={style.spacedBetweenRow}>
                  <FontAwesomeIcon
                    icon={filterBy.QuestionTypeNumber1OrText2 == 2 ? faCommentDots : faListOl}
                    style={{ flex: '0 0 auto', marginRight: 10 }}
                  />

                  <div id="filterQuestionText" style={style.filterButtonText}>
                    {filterBy.QuestionText}
                  </div>
                </div>
              </Button>
              {renderFilterPopover()}
              <UncontrolledTooltip target="filterQuestionText">{filterBy.QuestionText}</UncontrolledTooltip>
            </div>
            <Button
              size="sm"
              style={{ ...style.viewToggleButton, flex: '0 0 auto', marginBottom: 0 }}
              onClick={() => {
                setDisplayMode(displayMode === 'individual' ? 'distribution' : 'individual');
              }}
              title={displayMode === 'individual' ? 'Switch to Answer Distribution' : 'Switch to Individual Responses'}
            >
              <FontAwesomeIcon icon={displayMode === 'individual' ? faChartBar : faListOl} />
            </Button>
            <Button
              size="sm"
              style={{ flex: '0 0 auto' }}
              onClick={() => {
                setShowExpandedView(!showExpandedView);
              }}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} />
            </Button>
          </div>
          <div style={style.responsesContainer}>
            <div style={{ ...style.simpleColumn, width: '100%' }}>
              {displayMode === 'distribution' ? distributionContent : responsesToRender}
            </div>
          </div>
          {renderExpandedView()}
        </div>
      </div>
    </div>
  );
};

export default AdminRankResponses;
